<template>
  <div>

    <div v-if="url" style="height: calc(100vh - 50px); overflow-y: scroll; -webkit-overflow-scrolling: touch">
      <!-- <iframe style="height: 100%; width: 100%"  ref="iframe" scrolling="auto" frameborder="0"  id="iframe"></iframe> -->
      <iframe style="height: calc(100% - 1.5rem); width: 100%"  ref="iframe" scrolling="auto" frameborder="0"  id="iframe"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'kefu',
  data() {
    return {
      url: null,
      hasRendered: false,
    };
  },
  created() {
    let that = this;
    
      that.getservicerurl();
  
  },
  methods: {
    // 打开客服
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
          that.hasRendered = false;
        }
      });
    },
    renderIframeContent() {
      let that = this;
      if (that.hasRendered || !that.url || !that.$refs.iframe) return;

      const iframe = that.$refs.iframe;
      const content = String(that.url).trim();
      const isHttpUrl = /^https?:\/\//i.test(content);

      if (isHttpUrl) {
        try {
          iframe.contentWindow.location.replace(content);
        } catch (e) {
          iframe.src = content;
        }
        that.hasRendered = true;
        return;
      }

      // 兼容后端返回的第三方客服脚本片段（HTML + script）
      try {
        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(content);
        doc.close();
        that.hasRendered = true;
      } catch (e) {
        that.showTost(0, '客服页面加载失败');
      }
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    this.renderIframeContent();
  },
};
</script>

<style lang="scss" scoped>
// @import '../../../static/css/chunk-099d4415.690b75b1.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/kefu.vue